import { SizeVariantsDisplayType } from '../../../app-state-types/reducer-state-types/add-to-cart';

export const sizeVariantsTypes = [
  { value: SizeVariantsDisplayType.dropdown, label: 'Dropdown' },
  { value: SizeVariantsDisplayType.buttonBar, label: 'Button bar' },
];
